<template>
	<div id="app" ref="main">
		<navLi class="navurl" ref="navurl"></navLi>
		<div class="content" ref="content">
			<router-view />
		</div>
		<botFooter class="botFooter" ref="botFooter"></botFooter>
	</div>
</template>

<script>
	import navLi from "@/components/base/navLi.vue"
	import botFooter from "@/components/base/botFooter.vue"
	export default {
		components: {
			navLi,
			botFooter
		},
		data() {
			return {
				Height: 0
			};
		},
		mounted() {
			//动态设置内容高度 让footer始终居底   nav+footer的高度是246
			this.Height = document.documentElement.clientHeight - 246;
			//监听浏览器窗口变化
			window.onresize = () => {
				this.Height = document.documentElement.clientHeight - 246;
			};
			//在页面加载时读取sessionStorage里的状态信息
			if (localStorage.getItem("store")) {
				this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store"))));
			}
			// 在页面刷新时将vuex里的信息保存到sessionStorage里
			window.addEventListener("beforeunload", () => {
				this.$store.state.basePicUrl = "https://zhixueyuan.oss-cn-beijing.aliyuncs.com/officialWebsite/img/";
				localStorage.setItem("store", JSON.stringify(this.$store.state))
			})
		},
		methods: {

		}
	}
</script>

<style scoped>
	#app {
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	.navurl {
		height: 80px;

	}
	.botFooter {
		height: 175px;
	}
	.content {
		flex: 1;
		background: #F3F5F5;
		word-break: break-all;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue